import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import { MenuItem } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { degreeApi } from '../../../api/degree/degree.api';
import { facultyApi } from '../../../api/factulty/factulty.api';
import { routeName } from '../../../routes/routeName';
import { YearsApi } from '../../../api/yeas/years.api';

import { MyCourseOfStudyApi } from '../../../api/my-course-of-study/my-course-of-study.api';
import { AcademicYearApi } from '../../../api/academic-year/academic-year.api';
const defaultSearch = {
    id_faculty: 'ALL',
    year: "ทุกปีการศึกษา",
    term: "ทุกภาคเรียน",
    id_degree: 'ALL'
}
const defaultState = {
    id_faculty: 0,
    year: "",
    course_of_study_start_date: undefined,
    course_of_study_end_date: undefined,
    term: "",
    id_degree: 0
}


export default function StudentsCourseOfStudy() {
    // const currentYear = new Date().getFullYear() + 543; // ค.ศ. -> พ.ศ.
    // const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const [search, setSearch] = useState<any>(defaultSearch)
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);

    const [dataDegree, setDataDegree] = useState<any[]>([]);
    const [dataFaculty, setDataFaculty] = useState<any[]>([]);
    const [dataYears, setDataYears] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [open, setOpen] = useState<boolean>(false);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search.year !== 'ทุกปีการศึกษา') condition = { ...condition, academic_year: search.year };
            if (search.term !== 'ทุกภาคเรียน') condition = { ...condition, semester: search.term };
            if (search.id_degree !== 'ALL') condition = { ...condition, id_degree: search.id_degree }
            if (search.id_faculty !== 'ALL') condition = { ...condition, id_faculty: search.id_faculty }
            const res = await MyCourseOfStudyApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search.id_faculty, search.id_degree, search.year, search.term]);
    const fetchGetDegree = async () => {
        const res = await degreeApi.getDegree();
        const data = res.data;
        if (data.status < 300) {
            setDataDegree(data.data);
        } else {
            setDataDegree([]);
        }
    };

    const fetchGetFaculty = async () => {
        const res = await facultyApi.getFaculty();
        const data = res.data;
        if (data.status < 300) {
            setDataFaculty(data.data);
        } else {
            setDataFaculty([]);
        }
    };
    // const fetchGetYears = async () => {
    //     const res = await YearsApi.getYears();
    //     const data = res.data;
    //     if (data.status < 300) {
    //         setDataYears(data.data);
    //     } else {
    //         setDataYears([]);
    //     }
    // };
    const getAcademicYearList = async () => {
        let query: any = {
            page: 1,
            limit: 1000,
        }
        await AcademicYearApi.getAcademicYearListActive(query).then((res) => {
            if (res.status < 300) {
                setDataYears(res.data?.data.items.map((x: any) => { return { ...x, year: x?.academic_year } }) || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        fetchGetDegree()
        fetchGetFaculty()
        getAcademicYearList()
    }, [])
    useEffect(() => {
        loadData();
    }, [loadData]);

    const headCells = [
        {
            id: "#",
            width: '400px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: "ปีการศึกษา",
        },
        {
            id: "leave_type_name",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: "ภาคเรียนที่",
        },
      

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '80px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            academic_year,
            id_course_of_study,
            semester,
            estimate_start_date,
            estimate_end_date
        } = objData;

        const objRenderData = {
            key: id_course_of_study,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "start",
                    label: academic_year || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: semester,
                },
      

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            onViewClick={() => {
                                navigate(routeName.students.CourseOfStudyDetail.replace(':id', id_course_of_study).replace(':id_academic_year', semester), {state: {
                                    academic_year: academic_year,
                                    semester: semester
                                }})
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };


    return (
        <div>
            <ContentHeading
                title={"ตารางเรียน"}
                detail="กรุณาเลือกรายการที่ท่านต้องการ"
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.year || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[{ year: 'ทุกปีการศึกษา', }, ...dataYears].map((item: any, index: number) => (
                            <MenuItem value={item?.year} key={index + 1}>
                                {item?.year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("year", e.target.value)
                            setSearch({ ...search, year: e.target.value })
                        }}
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.term || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={['ทุกภาคเรียน', '1', '2', '3'].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch({ ...search, term: e.target.value })
                        }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>




            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data?.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div>

    )
}
